import { ChineseLogo } from '@packages/ui/components/ChineseLogo';
import { DefaultLogo } from '@packages/ui/components/DefaultLogo';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getCurrentLocale } from 'selectors/ui/ui';

type LogoProps = ConnectedProps<typeof connector> & {
  className?: string;
  size?: string;
};
const LogoComponent = ({ className, locale, size }: LogoProps) => {
  const showChineseLogo = locale === 'zh-CN';
  const Logo = showChineseLogo ? ChineseLogo : DefaultLogo;
  return <Logo size={size} className={className} />;
};

const mapStateToProps = (state: RootState) => {
  const locale = getCurrentLocale(state);
  return { locale };
};

const connector = connect(mapStateToProps);
const Logo = connector(LogoComponent);

export { Logo };
